import type { Engine } from '../types';
import { buildUrl } from '../url';

export const yelp: Engine = {
  id: 'yelp',
  name: 'Yelp',
  bang: 'yelp',
  aliases: [],
  homepage: 'https://www.yelp.com',
  category: 'Local',
  experimental: true,
  description: 'Local businesses near your zip or a place you name.',
  params: [
    {
      id: 'place',
      type: 'text',
      prefix: '@',
      pattern: /^[a-z0-9-]{2,40}$/,
      label: 'Near',
      group: 'Location',
      placeholder: 'tacoma-wa',
      help: 'A city or zip; dashes become spaces (@tacoma-wa). Defaults to your zip from Settings.',
    },
    {
      id: 'price',
      type: 'choice',
      label: 'Price',
      group: 'Filters',
      options: [
        { value: '1', token: 'p1', label: '$' },
        { value: '1,2', token: 'p2', label: '$$ and under' },
        { value: '2,3', token: 'p3', label: '$$–$$$' },
        { value: '3,4', token: 'p4', label: '$$$ and up' },
      ],
    },
    {
      id: 'open',
      type: 'flag',
      token: 'open',
      label: 'Open now',
      group: 'Filters',
      help: 'Best effort.',
    },
    {
      id: 'sort',
      type: 'choice',
      label: 'Sort',
      group: 'Sort',
      options: [
        { value: 'rating', token: 'rated', label: 'Highest rated' },
        { value: 'review_count', token: 'reviews', label: 'Most reviewed' },
      ],
    },
  ],
  build({ query, values, settings }) {
    const place =
      typeof values.place === 'string'
        ? values.place.replace(/-/g, ' ')
        : settings.zip;
    const price = typeof values.price === 'string' ? values.price : undefined;
    return buildUrl('https://www.yelp.com/search', {
      find_desc: query,
      find_loc: place,
      attrs: price
        ?.split(',')
        .map(n => `RestaurantsPriceRange2.${n}`)
        .join(','),
      open_now: values.open === true ? '1' : undefined,
      sortby: values.sort as string | undefined,
    });
  },
};
